(function () {
  'use strict';
  var root = document.querySelector('[data-hw-purchase-v1]');
  var dialog = root && root.querySelector('[data-hw-accessory-dialog]');
  var dataEl = document.getElementById('hw-data');
  if (!dialog || !dialog.showModal || !dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var money = new Intl.NumberFormat(data.locale || 'en', {style: 'currency', currency: data.currency || 'USD'});
  root.querySelectorAll('[data-hw-accessory-open]').forEach(function (link) {
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', dialog.id);
    link.addEventListener('click', function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var card = link.closest('[data-hw-item]');
      var item = JSON.parse(card.querySelector('[data-hw-item-data]').textContent);
      var select = card.querySelector('[data-hw-item-variant]');
      var selected = item.variants.find(function (variant) {return String(variant.id) === String(select ? select.value : item.variantId);}) || item.variants[0];
      if (!selected) return;
      event.preventDefault();
      event.stopPropagation();
      dialog.querySelector('[data-hw-accessory-title]').textContent = item.title;
      dialog.querySelector('[data-hw-accessory-variant]').textContent = selected.title === 'Default Title' ? '' : selected.title;
      var quote = selected.mode === 'quote';
      var catalog = selected.mode === 'catalog_only';
      dialog.querySelector('[data-hw-accessory-price]').textContent = quote ? data.labels.quote_required : catalog ? data.labels.unavailable : money.format(selected.priceCents / 100);
      dialog.querySelector('[data-hw-accessory-each]').hidden = quote || catalog;
      var content = card.querySelector('[data-hw-accessory-content]');
      var sourceImage = content && content.content.querySelector('.hw-accessory-source-image');
      var cardImage = card.querySelector('.hw-addon__img');
      var source = selected.imageUrl || (sourceImage && sourceImage.src) || (cardImage && cardImage.src);
      var image = dialog.querySelector('[data-hw-accessory-image]');
      image.hidden = !source;
      if (source) {
        var imageUrl = new URL(source, window.location.origin);
        if (imageUrl.pathname.includes('/cdn/shop/')) imageUrl.searchParams.set('width', '800');
        image.src = imageUrl.href;
        image.alt = item.title;
      }
      var body = dialog.querySelector('[data-hw-accessory-body]');
      body.replaceChildren();
      if (content) {
        var fragment = content.content.cloneNode(true);
        fragment.querySelectorAll('.hw-accessory-source-image,script,style,iframe,object,embed,form,input,button,textarea,select').forEach(function (element) {element.remove();});
        fragment.querySelectorAll('*').forEach(function (element) {
          Array.from(element.attributes).forEach(function (attribute) {
            if (/^on/i.test(attribute.name) || ['srcdoc','id','autofocus'].includes(attribute.name)) element.removeAttribute(attribute.name);
            if (['href','src','xlink:href','action'].includes(attribute.name) && /^\s*(javascript|vbscript|data):/i.test(attribute.value)) element.removeAttribute(attribute.name);
          });
        });
        fragment.querySelectorAll('a[href]').forEach(function (anchor) {anchor.target = '_blank';anchor.rel = 'noopener noreferrer';});
        body.appendChild(fragment);
      }
      var target = new URL(link.getAttribute('href'), window.location.origin);
      target.searchParams.set('variant', selected.id);
      dialog.querySelector('[data-hw-accessory-link]').href = target.pathname + target.search;
      dialog.showModal();
      document.body.classList.add('hw-accessory-open');
      dialog.querySelector('.hw-accessory-scroll').scrollTop = 0;
    });
  });
  dialog.querySelectorAll('[data-hw-accessory-close]').forEach(function (button) {button.addEventListener('click', function () {dialog.close();});});
  dialog.addEventListener('close', function () {document.body.classList.remove('hw-accessory-open');});
  dialog.addEventListener('click', function (event) {event.stopPropagation();});
})();
